import { useTranslation } from "react-i18next";
import { Autocomplete, Box, TextField } from "@mui/material";

import AutocompleteIcon from "../../assets/icons/MUI/ComponentsIcons";
import { entityGenderEnum, entityRoleEnum } from "../../enums/entity.enum";
import { entityGender, entityRoles } from "../../constants/prefilled.constants";
import { useCountryListing } from "../../api/queries/network/useCountryListing";

const GoStarFilter = ({
  isLoading,
  setIsLoading,
  gender,
  setGender,
  nationality,
  setNationality,
  country,
  setCountry,
  persona,
  setPersona,
  roleTab,
}: {
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  gender: {
    label: string;
    value: entityGenderEnum;
  } | null;
  setGender: React.Dispatch<
    React.SetStateAction<{
      label: string;
      value: entityGenderEnum;
    } | null>
  >;
  nationality: {
    label: string;
    value: string;
  } | null;
  setNationality: React.Dispatch<
    React.SetStateAction<{
      label: string;
      value: string;
    } | null>
  >;
  country: {
    label: string;
    value: string;
  } | null;
  setCountry: React.Dispatch<
    React.SetStateAction<{
      label: string;
      value: string;
    } | null>
  >;
  persona: {
    label: string;
    value: entityRoleEnum;
  } | null;
  setPersona: React.Dispatch<
    React.SetStateAction<{
      label: string;
      value: entityRoleEnum;
    } | null>
  >;
  roleTab: number;
}) => {
  const { t } = useTranslation();

  const { countries, nationalities } = useCountryListing();

  return (
    <Box
      sx={{
        width: "100%",
        overflowX: "auto",
        whiteSpace: "nowrap",
        padding: "0 8px 8px 0",
      }}
    >
      <Box
        sx={{
          height: "40px",
          width: "fit-content",
          display: "flex",
          gap: "10px",
        }}
      >
        {roleTab === 1 && (
          <Autocomplete
            options={
              entityRoles
                .filter((el) => el.label !== "Player")
                .map((el) => ({
                  ...el,
                  label: t(`enums.persona.role.${el.label.toLocaleUpperCase()}`),
                })) || []
            }
            disabled={isLoading}
            value={persona}
            onChange={(event, option) => {
              setPersona(option || null);
            }}
            sx={{
              width: "140px",
            }}
            popupIcon={<AutocompleteIcon />}
            getOptionLabel={(option) => option.label}
            isOptionEqualToValue={(option, value) => option.value === value?.value}
            renderInput={(params) => (
              <TextField
                {...params}
                inputProps={{
                  ...params.inputProps,
                  style: { fontSize: "14px" },
                }}
                placeholder={t("pages.goStar.role")}
              />
            )}
          />
        )}

        <Autocomplete
          options={countries || []}
          disabled={isLoading}
          value={country}
          onChange={(event, option) => {
            setCountry(option || null);
          }}
          sx={{
            width: "200px",
          }}
          popupIcon={<AutocompleteIcon />}
          getOptionLabel={(option) => option.label}
          isOptionEqualToValue={(option, value) => option.value === value?.value}
          renderInput={(params) => (
            <TextField
              {...params}
              inputProps={{
                ...params.inputProps,
                style: { fontSize: "14px" },
              }}
              placeholder={t("pages.goStar.country")}
            />
          )}
        />

        {roleTab !== 2 && (
          <Autocomplete
            options={nationalities || []}
            disabled={isLoading}
            value={nationality}
            onChange={(event, option) => {
              setNationality(option || null);
            }}
            sx={{
              width: "300px",
            }}
            popupIcon={<AutocompleteIcon />}
            getOptionLabel={(option) => option.label}
            isOptionEqualToValue={(option, value) => option.value === value?.value}
            renderInput={(params) => (
              <TextField
                {...params}
                inputProps={{
                  ...params.inputProps,
                  style: { fontSize: "14px" },
                }}
                placeholder={t("pages.goStar.nationality")}
              />
            )}
          />
        )}

        {roleTab !== 2 && (
          <Autocomplete
            options={
              entityGender.map((el) => ({
                ...el,
                label: t(`constant.gender.${el.label}`),
              })) || []
            }
            disabled={isLoading}
            value={gender}
            onChange={(event, option) => {
              setGender(option || null);
            }}
            sx={{
              width: "125px",
            }}
            popupIcon={<AutocompleteIcon />}
            getOptionLabel={(option) => option.label}
            isOptionEqualToValue={(option, value) => option.value === value?.value}
            renderInput={(params) => (
              <TextField
                {...params}
                inputProps={{
                  ...params.inputProps,
                  style: { fontSize: "14px" },
                }}
                placeholder={t("pages.goStar.gender")}
              />
            )}
          />
        )}
      </Box>
    </Box>
  );
};

export default GoStarFilter;
